import type { FC } from 'react';
import React from 'react';

import { getClassNames } from './FluentUISystemIcon.styles.legacy';
import type { FluentUISystemIconProps } from './FluentUISystemIcon.types';

const FluentUISystemIcon: FC<FluentUISystemIconProps> = ({ block = false, className, color, size, Icon, testId }) => (
  <Icon className={getClassNames(block, color, size, className).fluentUISystemIcon} data-testid={testId} />
);

export default FluentUISystemIcon;
